import { BankPayment } from "./bank-payment";
import { CardPayment } from "./card-payment";
import { CashPayment } from "./cash-payment";
import { CouponPayment } from "./coupon-payment";
import { GatewayPayment } from "./gateway-payment";
import { PaytmPaymentDto } from "./paytm-payment-dto";
import { SwipePayment } from "./swipe-payment";
import { UpiPayment } from "./upi-payment";
import { WalletPayment } from "./wallet-payment";


export class CommonPayments {

    amount: number;
    cashPayment: CashPayment = new CashPayment();
    cardPayment: CardPayment = new CardPayment();
    couponPayment: CouponPayment = new CouponPayment();
    bankPayment: BankPayment = new BankPayment();
    upiPayment: UpiPayment = new UpiPayment();
    paytmPayment: PaytmPaymentDto = new PaytmPaymentDto();
    walletPayment: WalletPayment = new WalletPayment();
    swipePayment: SwipePayment = new SwipePayment();
    gatewayPayment: GatewayPayment = new GatewayPayment();

    // added for cash register
    refundAmt?: number = 0;
    couponPaymentAllowed?: boolean = true;

    //added for wallet
    customerEmail: string;
    transactionPoint: string;
    moduleName: string;

    locationCode: number;
    companyCode: number;

}
